import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import apiSlice from "src/services/ApiSlice";
import { sideNavLayoutSlice } from "./slices";
import AccountSlice from "./slices/AccountSlice";
import AuthSlice from "./slices/AuthSlice";
import ConfigurationLayoutSlice from "./slices/ConfigurationLayoutSlice";
// import CountrySlice from "./slices/CountrySlice";
import { authMiddleware } from "src/utils";
import CountrySlice from "./slices/CountrySlice";
import StatesSlice from "./slices/StatesSlice";
import CitySlice from "./slices/CitySlice";
import CourseSlice from "./slices/CourseSlice";
import ExpenseCategorySlice from "./slices/ExpenseCategorySlice";
import BranchSlice from "./slices/BranchSlice";
import ModeSlice from "./slices/ModeSlice";
import ModuleSlice from "./slices/ModuleSlice";
import ChapterSlice from "./slices/ChapterSlice";
import HoliDayCalendarSlice from "./slices/HolidayCalendarSlice";
import InquirySlice from "./slices/InquirySlice";
import { filePickerSlice } from "src/services/FilePickerServices";
import ExpensesSlice from "./slices/ExpensesSlice";
import LanguageSlice from "./slices/LanguageSlice";
import FinanceLayoutSlice from "./slices/FinanceLayoutSlice";
import MarketingLayoutSlice from "./slices/MarketingLayoutSlice";
import CampaignSlice from "./slices/CampaignSlice";
import ChannelSlice from "./slices/ChannelSlice";
import DispositionLevelOneSlice from "./slices/DispositionLevelOneSlice";
import DispositionLevelTwoSlice from "./slices/DispositionLevelTwoSlice";
import CampaignGroupSlice from "./slices/CampaignGroupSlice";
import TrainerSlice from "./slices/TrainerSlice";
import CommunicationMethodSlice from "./slices/CommunicationMethodSlice";
import StudentSlice from "./slices/StudentSlice";
import CouponSlice from "./slices/CouponSlice";
import FollowUpSlice from "./slices/FollowUpSlice";
import BatchSlice from "./slices/BatchSlice";
import UpcomingInstallmentSlice from "./slices/UpcomingInstallmentSlice";
import PaymentHistorySlice from "./slices/PaymentHistorySlice";
import UserSlice from "./slices/UserSlice";
import UserAcessSlice from "./slices/access/userAcessSlice";
import TransactionsSlice from "./slices/TransactionsSlice";
import PendingFollowupSlice from "./slices/PendingFollowupSlice";
import BatchesStudentSlice from "./slices/BatchesStudentSlice";
import BatchStudentAttendanceSlice from "./slices/BatchStudentAttendanceSlice";
import QuestionBankSlice from "./slices/QuestionBankSlice";
import AssignmentSlice from "./slices/AssignmentSlice";
import StudentAssignmentSlice from "./slices/StudentAssignmentSlice";
import SubCourseSlice from "./slices/SubCourseSlice";
import InquiryLabelsSlice from "./slices/InquiryLabelsSlice";
import ResourceSlice from "./slices/ResourceSlice";
import BatchRecordingSlice from "./slices/BatchRecordingSlice";
import AssetsSlice from "./slices/AssetsSlice";
import RegistrationLinkSlice from "./slices/RegistrationLinkSlice";
import RegistrationRequestsSlice from "./slices/RegistrationRequestsSlice";
import UpComeingPaymentsSlice from "./slices/UpComeingPaymentsSlice";
import TeamResourcesSlice from "./slices/TeamResourcesSlice";
import GoalCategoriesSlice from "./slices/GoalCategoriesSlice";
import GoalSlice from "./slices/GoalSlice";
import GoalViewSlice from "./slices/GoalViewSlice";
import NewInquirySlice from "./slices/NewInquirySlice";
import JobBoardSlice from "./slices/JobBoardSlice";
import RecordingRequestSlice from "./slices/RecordingRequestSlice";
import StudentTestimonialSlice from "./slices/StudentTestimonialSlice";
import BlogSlice from "./slices/BlogSlice";
import QuestionCategorySlice from "./slices/QuestionTechnologySlice";
import QuestionTechnologySlice from "./slices/QuestionTechnologySlice";
import TestQuestionSlice from "./slices/TestQuestionSlice";
import TestSeriesSlice from "./slices/TestSeriesSlice";
import TestCheckSlice from "./slices/TestCheckSlice";
import WebcourseSlice from "./slices/WebcourseSlice";
import RecordingRulesSlice from "./slices/RecordingRulesSlice";
import dashboardSlice from "./slices/dashboardSlice";
import FinanceDashboadSlice from "./slices/FinanceDashboadSlice";

const store = configureStore({
  reducer: {
    auth: AuthSlice,
    userAccess: UserAcessSlice,
    sideNavLayout: sideNavLayoutSlice,
    configurationLayout: ConfigurationLayoutSlice,
    country: CountrySlice,
    states: StatesSlice,
    city: CitySlice,
    account: AccountSlice,
    branch: BranchSlice,
    mode: ModeSlice,
    module: ModuleSlice,

    course: CourseSlice,
    subCourse: SubCourseSlice,

    expenseCategory: ExpenseCategorySlice,
    chapter: ChapterSlice,
    HoliDayCalendar: HoliDayCalendarSlice,
    inquiry: InquirySlice,
    expenses: ExpensesSlice,
    language: LanguageSlice,
    financeLayout: FinanceLayoutSlice,
    marketingLayout: MarketingLayoutSlice,
    channel: ChannelSlice,
    dispositionLevelOne: DispositionLevelOneSlice,
    dispositionLevelTwo: DispositionLevelTwoSlice,
    campaign: CampaignSlice,
    campaignGroup: CampaignGroupSlice,
    trainer: TrainerSlice,
    communicationMethod: CommunicationMethodSlice,

    student: StudentSlice,
    studentAssignment: StudentAssignmentSlice,

    inquryLabel: InquiryLabelsSlice,
    coupon: CouponSlice,
    followUp: FollowUpSlice,

    batch: BatchSlice,
    batchesStudent: BatchesStudentSlice,
    batchesattendance: BatchStudentAttendanceSlice,
    assignment: AssignmentSlice,
    batchRecording: BatchRecordingSlice,

    upcomingInstallment: UpcomingInstallmentSlice,
    paymentHistory: PaymentHistorySlice,
    user: UserSlice,
    transactions: TransactionsSlice,
    pendingFollowup: PendingFollowupSlice,
    questionBank: QuestionBankSlice,
    jobBoard: JobBoardSlice,
    studentTestimonial: StudentTestimonialSlice,
    blogs: BlogSlice,

    resource: ResourceSlice,
    teamResourcesSlice: TeamResourcesSlice,
    assets: AssetsSlice,

    registrationLink: RegistrationLinkSlice,
    registrationRequest: RegistrationRequestsSlice,

    upComeingPayments: UpComeingPaymentsSlice,
    goalCategories: GoalCategoriesSlice,
    goal: GoalSlice,
    goalView: GoalViewSlice,
    newInquiry: NewInquirySlice,

    recordingRequest: RecordingRequestSlice,
    questionCategory: QuestionCategorySlice,
    questionTechnology: QuestionTechnologySlice,
    testQuestion: TestQuestionSlice,
    testSeries: TestSeriesSlice,
    testCheck: TestCheckSlice,
    webcourse: WebcourseSlice,
    recordingRules: RecordingRulesSlice,
    dashboard: dashboardSlice,
    financeDashboad : FinanceDashboadSlice,

    [apiSlice.reducerPath]: apiSlice.reducer,
    [filePickerSlice.reducerPath]: filePickerSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([
      authMiddleware,
      apiSlice.middleware,
      filePickerSlice.middleware,
    ]),
});

setupListeners(store.dispatch);
export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
